import {css} from '@emotion/react'
import Icon from '@ant-design/icons'
import * as AntdIcons from '@ant-design/icons'
import http from '@/biz/http.mjs'
import runAsync from "@/script/runAsync.mjs"
import useSwrNoCache from '@/script/useSwrNoCache.mjs'

const cssIcon = css({
    color: 'whitesmoke',
    fontSize: 14,
})

export default () => {
    const {data, isLoading} = useSwrNoCache(
        () => runAsync(
            () => http.get('/basMenuExtension/listEnableBasMenuExtension'),

            {
                action: '查询扩展菜单',
                loading: {show: false},
            }
        ),
    )

    if (isLoading) {
        return [{
            key: 'extended',
            icon: <AntdIcons.LoadingOutlined />,
        }]
    }

    if (! data) {
        return []
    }

    const mapMenuItem = ({
        children,
        menuCode,
        menuIcon,
        menuIconColor,
        menuName,
        menuPath,
    }) => {
        const icon = menuIcon ?
            (
                <Icon
                    css={cssIcon}
                    style={{color: menuIconColor}}
                    component={AntdIcons[menuIcon]}
                />
            )
            :
            null

        const item = {
            key: menuCode,
            icon,
            title: menuName,
            onClick: () => window.open(menuPath)
        }

        if (children) {
            item.children = children.map(mapMenuItem)
        }

        return item
    }

    return data.map(mapMenuItem)
}
